import firebase from "firebase";

export interface User {
  allowMarketingEmails: boolean;
  firstName: string;
  lastName: string;
  lastUsedDatabase: string;
  id: string;
}

export const userConverter = {
  toFirestore: function (database: User) {
    throw new Error("Unimplemented");
  },

  fromFirestore: function (
    snapshot: firebase.firestore.QueryDocumentSnapshot
  ): User {
    const data: firebase.firestore.DocumentData = snapshot.data();

    return {
      allowMarketingEmails: data.allowMarketingEmails,
      firstName: data.firstName,
      lastName: data.lastName,
      lastUsedDatabase: data.lastUsedDatabase,
      id: data.user,
    };
  },
};
